// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3lJX0","imageUploader":"EGiftCard_imageUploader__1oYI0"};